import { useState } from 'react';
import { AgCharts } from 'ag-charts-react';
import { EndpointUsageChartLogic } from './EndpointUsageChart';
import './EndpointUsageChart.scss';
import {
    ClientSideRowModelModule,
    ModuleRegistry,
} from 'ag-grid-enterprise';
import { Modal, Button, Spin } from 'antd';
import { ExpandAltOutlined } from '@ant-design/icons';
import LoadingOrbitalSpinner from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

function EndpointUsageChart({ startAndEndUnixDatesParams = '' }) {
    const { chartConfig, loading } = EndpointUsageChartLogic(startAndEndUnixDatesParams);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <Spin spinning={loading} indicator={<LoadingOrbitalSpinner />}>
            <div className='endpoint-chart'>
                <div className='endpoint-chart-wrapper'>
                    <Button
                        className='endpoint-chart-expand-btn'
                        type='text'
                        size='small'
                        icon={<ExpandAltOutlined />}
                        onClick={() => setModalOpen(true)}
                    />
                    {chartConfig && <AgCharts options={chartConfig} />}
                </div>
                <Modal
                    centered
                    open={modalOpen}
                    onCancel={() => setModalOpen(false)}
                    footer={null}
                    width='90%'
                >
                    {chartConfig && <AgCharts options={chartConfig} style={{ height: '70vh' }} />}
                </Modal>
            </div>
        </Spin>
    );
}

export default EndpointUsageChart;
